<template>
    <div class="bgray-100">
        <router-view name="header"></router-view>

        <b-container class="py-5 vh-adjust">
            <b-row class="justify-content-center">
                <b-col class="col-sm-10">
                    <router-view></router-view>
                </b-col>
            </b-row>
        </b-container>

        <router-view name="footer"></router-view>

        <!-- 도움이 필요하신가요 모달 -->
        <b-button id="need-help" v-b-tooltip.hover.focus class="rounded-circle position-fixed" variant="dark" size="lg" :title="$t('도움이 필요하신가요?')" :aria-label="$t('도움이 필요하신가요?')" @click="showNeedHelp"><fa icon="question"></fa></b-button>
        <b-modal ref="need-help" size="lg" :title="$t('서비스 문의하기')"  hide-footer><customer-service @close-need-help="hideNeedHelp"></customer-service></b-modal>

        <!-- IE 제한 안내문구 -->
        <div v-if="show_alert==true && isIE === true" class="top-alert w-100">
            <b-alert show dismissible class="ie-alert text-center">
            {{$t('본 시스템은 Google Chrome 또는 Microsoft Edge에 최적화되어 있음을 알려드립니다. (ex. 인터넷익스플로러는 출력 사용불가)')}}
            </b-alert>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CustomerService from '@shared_components/utils/CustomerService'

export default {
    name: "MainMaster",
    components: { CustomerService },
    data() {
        return {}
    },
    computed:{
        ...mapState(['user_id', 'company_id']),
        show_alert(){
            return this.$store.state.login_alert
        }
    },
    methods: {
        showNeedHelp(){
            this.$refs['need-help'].show()
        },
        hideNeedHelp(){
            this.$refs['need-help'].hide()
        }
    }
}
</script>

<style>
#need-help {
    bottom: 30px;
    right: 30px;
}
/* 휴대폰에선 작게, 푸터 링크·저작권 줄 위로 올린다 */
@media (max-width: 575.98px) {
    #need-help {
        bottom: 80px;
        right: 16px;
        transform: scale(.8);
    }
}
.top-alert {
    position: absolute;
    top:50px;
    left: 0;
}
.bottom-alert{
    position: fixed;
    bottom:0;
    left: 0;
}
.ie-alert{
    position: sticky;
    /* background-color: rgba(0,0,0,0.5); */
    border:0;
    border-radius: 0;
    /* color: var(--gray-200); */
}

</style>